module.exports = __webpack_public_path__ + "static/media/ic-rapido.a9655805.svg";